// extracted by mini-css-extract-plugin
export var avatar = "_mt-3";
export var avatarContainer = "_mt-2";
export var avatarSpacer = "_mt-5";
export var avatarSpacerContainer = "_mt-4";
export var avatarStackContainer = "_mt-1";
export var bubble = "_mt-0";
export var remainderBubble = "_mt-6";